import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSections } from "@/contexts/classified";
import { Box } from "@gemini/core";
import { TrainIcon } from "@gemini/icons";
import { TransportTypeIcon } from "./TransportTypeIcon/TransportTypeIcon";
import { TransportLineIcon } from "./TransportLineIcon/TransportLineIcon";
import { useI18n } from "@/shared/hooks";
export const PublicTransports = () => {
    var _a;
    const { t } = useI18n();
    const { transport } = ((_a = useSections()) === null || _a === void 0 ? void 0 : _a.location) || {};
    const { closestLines } = transport || {};
    if (!closestLines)
        return;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { display: "flex", marginBottom: "spacing.16", marginTop: "spacing.16", children: [_jsx(TrainIcon, {}), _jsx(Box, { as: "span", typography: "typography.body.16.bold", marginLeft: "spacing.12", children: t("location.public_transports.headline") })] }), _jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.16", children: closestLines.map((group) => (_jsxs(Box, { display: "flex", gap: "spacing.4", alignItems: "start", children: [_jsx(Box, { width: "sizing.24", display: "flex", children: _jsx(TransportTypeIcon, { type: group.type, size: "24" }) }), _jsx(Box, { display: "flex", flexWrap: "wrap", gap: "spacing.4", children: group.lines.map((line) => (_jsx(TransportLineIcon, { line: line, type: group.type, BoxProps: {
                                    height: "sizing.24",
                                    minWidth: "sizing.24",
                                    typography: "typography.body.12.bold",
                                } }, line.name))) })] }, group.type))) })] }));
};
